import apple from './apple.js'
import qobuz from './qobuz.js'
import soundcloud from './soundcloud.js'
import spotify from './spotify.js'
import tidal from './tidal.js'
import youtube from './youtube.js'
import type { ServiceEmbed } from './types.js'

const services: Record<string, ServiceEmbed> = {
  youtube,
  spotify,
  tidal,
  soundcloud,
  apple,
  qobuz,
}
export default services
